/*
 * MN — Tope de cantidad segun el stock real.
 *
 * El numero disponible lo calcula Liquid en `sections/main-product.liquid`
 * (bloque `quantity_selector`) y viaja en el atributo `data-max` del campo de
 * cantidad. Este archivo solo se encarga de que ese numero llegue al atributo
 * `max` de verdad cada vez que cambia.
 *
 * POR QUE HACE FALTA ESTO
 * -----------------------
 * Dawn ya sabe leer `data-max`, pero al cambiar de talla lo hace en el orden
 * equivocado. En `product-info.js`, `updateQuantityRules()`:
 *
 *   1. llama a `setQuantityBoundries()`, que calcula el tope con los datos de
 *      la variante ANTERIOR;
 *   2. y DESPUES copia el `data-max` de la variante nueva;
 *   3. y ya no vuelve a calcular nada.
 *
 * Resultado: eliges una talla con cinco unidades y el campo sigue con el tope
 * de la talla anterior. Nunca se habia notado porque `data-max` solo existe si
 * se ponen limites de compra a mano en el admin, cosa que casi nadie hace.
 *
 * POR QUE NO SE PARCHEA DAWN
 * --------------------------
 * Se probo, anadiendo una segunda llamada a `setQuantityBoundries()` al final
 * de ese metodo. Fue peor: esa funcion termina con
 *
 *     this.quantityInput.value = min;
 *
 * o sea que REESCRIBE el valor del campo, y ademas se la llama en cada cambio
 * del carrito. El numero se reiniciaba solo en momentos en los que antes no lo
 * hacia. Se revirtio.
 *
 * Aqui se toca unicamente `max`. El valor se ajusta solo si se ha quedado por
 * encima del nuevo tope, que es una correccion esperable —eliges una talla con
 * dos unidades teniendo un cinco puesto— y nunca al azar.
 *
 * Va en un archivo propio, no dentro de `product-info.js`, para que una futura
 * actualizacion de Dawn no se lo lleve por delante.
 */

(function () {
  function apply(input) {
    const raw = input.dataset.max;

    // Sin `data-max` no hay nada que limitar: puede ser una variante sin
    // control de inventario, o con politica de seguir vendiendo sin stock.
    // En ese caso no se toca nada y manda Dawn.
    if (raw === undefined || raw === '') return;

    const max = parseInt(raw, 10);
    const inCart = parseInt(input.dataset.cartQuantity || '0', 10) || 0;
    if (!Number.isFinite(max)) return;

    const available = max - inCart;

    /* Si ya se tiene en el carrito todo el stock, `available` es 0 o negativo.
       No se escribe un `max` de 0: un campo con `min="1"` y `max="0"` es un
       estado imposible, el navegador lo marca como invalido y el mensaje que
       sale no explica nada. Se deja como este y que el servidor rechace el
       exceso, que al menos da un error con sentido. */
    if (available <= 0) return;

    if (parseInt(input.max, 10) !== available) input.max = available;

    const current = parseInt(input.value, 10);
    if (Number.isFinite(current) && current > available) input.value = available;
  }

  function watch(input) {
    if (input.dataset.mnCapBound) return;
    input.dataset.mnCapBound = '1';

    apply(input);

    /* Se vigilan SOLO los dos atributos que Dawn reescribe al cambiar de
       variante. Es importante que `max` no este en la lista: como esta funcion
       escribe `max`, incluirlo crearia un bucle. */
    new MutationObserver(() => apply(input)).observe(input, {
      attributes: true,
      attributeFilter: ['data-max', 'data-cart-quantity'],
    });
  }

  function init() {
    document.querySelectorAll('product-info .quantity__input').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
